import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-site-in-maintenance",
  standalone: true,
  imports: [RouterModule],
  templateUrl: "./site-in-maintenance.component.html",
  styleUrl: "./site-in-maintenance.component.less",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteInMaintenanceComponent {}
